import messages_de from "./de.json";
import messages_en from "./en.json";
import messages_es from "./es.json";
import messages_fr from "./fr.json";
import messages_ja from "./ja.json";
import messages_zh_cn from "./zh_cn.json";
import messages_zh_tw from "./zh_tw.json";
import messages_pl from "./pl.json";
import messages_pt_br from "./pt_br.json";

export const messages: any = {
    "de": messages_de,
    "en": messages_en,
    "es": messages_es,
    "fr": messages_fr,
    "ja": messages_ja,
    "zh-cn": messages_zh_cn,
    "zh-tw": messages_zh_tw,
    "pl": messages_pl,
    "pt-br": messages_pt_br,
};
